export const BillingIssueMessageTypes = {
    Rejection: 1,
    Reply: 2,
    Accepted: 3,
};
